import { dehydrate } from 'react-query';
import { CONSUMER_CMS_ABROAD } from '@vfit/consumer/data-access';
import { LandingAbroad } from '@vfit/consumer/abroad';

import { prefetchAllQueries } from '@vfit/cms';

export default function PageBuilder() {
  return <LandingAbroad />;
}

export async function getStaticProps() {
  const queryClient = await prefetchAllQueries(CONSUMER_CMS_ABROAD);
  return {
    props: {
      page: {
        params: {
          showPages: true,
          haveFooter: true,
          haveHeader: true,
          isHeaderSmall: false,
          isDisabledInitialTrack: false,
          isProtected: false,
          elements: {
            seo: {
              title: 'Offerte FWA: Casa Wireless 4G | Vodafone',
              ogImageUrl:
                'https://www.vodafone.it/nw/content/dam/webaem/vodafone/consumer/images/ico_header_logo_red_seo.png',
              ogDescription:
                'Scopri le Offerte FWA Vodafone per navigare da casa anche senza linea fissa, beneficiando delle performance della Rete Vodafone.',
            },
          },
        },
      },
      dehydratedState: dehydrate(queryClient),
    },
  };
}
